import { esMoneda, type Moneda } from '@mc/comercio'
import { useQuery } from '@tanstack/react-query'
import type { CSSProperties } from 'react'

import { consulta, pedir } from '../api/nucleo'
import type { Lista } from '../api/tipos'
import { colorDeMarca, textoSobre } from './previa'

/**
 * El color de marca y la moneda de la web, de sus Ajustes: el lienzo y la vista previa del
 * formulario se pintan con ese color (el botón, la barra de pasos, el foco), y un pago se
 * enseña en esa moneda. Si no hay color en Ajustes, el violeta del panel.
 */
type Ajustes = { colores?: { primario?: unknown } | null; tienda?: { moneda?: unknown } | null }

export const useMarcaDeLaWeb = (sitio: number) => {
  const { data } = useQuery({
    queryKey: ['ajustes-marca', sitio],
    queryFn: async () =>
      (
        await pedir<Lista<Ajustes>>(
          `/ajustes${consulta({ 'where[sitio][equals]': sitio, limit: 1, depth: 0 })}`,
        )
      ).docs[0] ?? null,
    staleTime: 5 * 60_000,
    retry: false,
  })
  const color = colorDeMarca(data?.colores?.primario)
  const deLaTienda = data?.tienda?.moneda
  const moneda: Moneda = esMoneda(deLaTienda) ? deLaTienda : 'PEN'
  const estilo = {
    '--marca': color ?? 'var(--color-violeta)',
    '--texto-marca':
      color && textoSobre(color) === 'oscuro'
        ? 'var(--texto-sobre-claro)'
        : 'var(--texto-sobre-oscuro)',
  } as CSSProperties
  return { color, moneda, estilo }
}
